'use client'

import type { DetailedHTMLProps, HTMLAttributes, HtmlHTMLAttributes } from 'react'

export interface PictureProps extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
    path: string
    sizes: number[]
    alt?: string
    width: number
    height: number
    primaryFormat?: 'jpg' | 'png'
    loading?: 'eager' | 'lazy'
    imageProps?: DetailedHTMLProps<HtmlHTMLAttributes<HTMLImageElement>, HTMLImageElement>
}

function srcSetPath(path: string, size: number, format: 'webp' | 'jpg' | 'png') {
    return `${path}${size}.${format} ${size}w`
}

export function Picture({
    alt,
    path,
    sizes,
    width,
    height,
    primaryFormat = 'jpg',
    loading,
    imageProps,
    ...props
}: PictureProps) {
    const largestSize = sizes[sizes.length - 1]
    const sizesMQ = `(max-width: ${largestSize}px) 100vw, ${largestSize}px`

    return (
        <picture {...props}>
            <source
                sizes={sizesMQ}
                type="image/webp"
                srcSet={sizes.map((size) => srcSetPath(path, size, 'webp')).join(',')}
            />
            {/* biome-ignore lint/a11y/useAltText: will be provided */}
            <img
                sizes={sizesMQ}
                srcSet={sizes.map((size) => srcSetPath(path, size, primaryFormat)).join(',')}
                src={`${path}${largestSize}.${primaryFormat}`}
                alt={alt}
                width={width}
                height={height}
                loading={loading}
                {...imageProps}
            />
        </picture>
    )
}
